import { connect } from 'react-redux';
import { StoreState } from '../../../reducers';

import LockedEditorPopup from '../../../components/Editor/LockedEditorPopup';
import { getClientAndResourceIds } from '../utils/helpers';
import DriveItemUtils from '../../../utils/driveItem';

const mapStateToProps = (state: StoreState) => {
	const {
		editor: {
			lockedEditorPopup: { isDisplayed, userName },
			parentFolderId,
		},
		driveList: { driveItems },
	} = state;
	const { tempGId, originalGId } = getClientAndResourceIds();
	const driveItem = driveItems[tempGId] || driveItems[originalGId];

	return {
		isDisplayed,
		userName,
		parentId: parentFolderId,
		isProposal: driveItem && DriveItemUtils.isProposal(driveItem.format),
	};
};

export default connect(mapStateToProps)(LockedEditorPopup);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/LockedEditorPopup/index.tsx